module.exports = __webpack_public_path__ + "static/media/Logo_diesel.65533d1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Logo_diesel.svg
// module id = 163
// module chunks = 0